import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";

export const SuccessPanel = ({ onReset }) => {
  const { t } = useLanguage();
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4 }}
      className="flex flex-col items-center justify-center px-6 py-20 text-center"
      data-testid="portal-success"
    >
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[rgba(15,118,110,0.12)]">
        <CheckCircle2 className="h-9 w-9 text-[var(--success)]" />
      </div>
      <h3 className="mt-5 font-heading text-2xl font-bold text-[var(--brand-navy)]">{t.portal.successTitle}</h3>
      <p className="mt-2 max-w-md text-sm text-[var(--muted-ink)]">{t.portal.successBody}</p>
      <Button onClick={onReset} className="mt-6 h-11 rounded-xl bg-[var(--brand-burgundy)] px-6 font-semibold text-white hover:bg-[var(--brand-burgundy-dark)]" data-testid="portal-send-another">
        {t.portal.sendAnother}
      </Button>
    </motion.div>
  );
};
